intra_module.factory('Module', function($resource, modules_url) {
    const m_url  = `${modules_url}/:module_id`;
    const params =
        {module_id: '@id'};
    const actions = {
        getPossibleMetaAcls: {
            method:  'GET',
            url:     `${m_url}/conversations/circles`,
            isArray: true,
            params: {
                module_id: '@module_id'
            }
        }
    };
    return $resource(m_url, params, actions);
});
